import { Box, Button, Dialog, Heading, Text } from '@betterment/samba-react';

const EmailVerificationEmailResentDialog = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (arg0: boolean) => void;
}) => (
  <Dialog open={isOpen} onOpenChange={setIsOpen}>
    <Dialog.Content size="large">
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: 'space.400',
          gap: 'space.200',
        }}
      >
        <Dialog.Title asChild={true}>
          <Heading variant="title300">We’ve resent the verification email</Heading>
        </Dialog.Title>
        <Dialog.Description asChild={true}>
          <Text as="p">Check your email and open the verification link we sent.</Text>
        </Dialog.Description>
        <Button onClick={() => setIsOpen(false)}>Got it</Button>
      </Box>
    </Dialog.Content>
  </Dialog>
);

export default EmailVerificationEmailResentDialog;
